module.exports = __webpack_public_path__ + "trace-25.279426530a4a363020d1.svg";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/assets/images/trace-25.svg
// module id = ../../../../../../../../../../digicerba-common-module/src/assets/images/trace-25.svg
// module chunks = 2